<script>
import UserIntegral from "@/layouts/website/components/WH/WFRC/UserIntegral.vue";
import VideoPlay from "@/layouts/website/components/WH/WFRC/VideoPlay.vue";
import NoticeMessage from "@/layouts/website/components/WH/WFRC/NoticeMessage.vue";
import AccountInfo from "@/layouts/website/components/WH/WFRC/AccountInfo.vue";
import {mapGetters} from "vuex";

export default {
  name: "WFRight",
  components: {
    UserIntegral,
    VideoPlay,
    NoticeMessage,
    AccountInfo,
  },
  computed: {
    ...mapGetters(["is_login"]),
  }
};
</script>

<template>
  <div class="wf-right">
    <UserIntegral v-if="is_login"/>
    <VideoPlay />
    <NoticeMessage />
    <AccountInfo />
  </div>
</template>

<style lang="scss" scoped>
.wf-right {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  white-space: nowrap;
}
</style>
